"use strict";

angular.module("customer")
.service("ProductDetailsModalService", function($resource, FlashBag, ModalService, appConfig) {
    var customerResource = $resource(appConfig.API_SERVER + "/catalog/customer/products/details/:id/", {id: "@id"}, {
        get: {
            method: "GET",
            isArray: false
        }
    });
    var salesRepResource = $resource(appConfig.API_SERVER + "/catalog/sales-rep/products/details/:id/", {id: "@id"}, {
        get: {
            method: "GET",
            isArray: false
        }
    });

    function getProductDetails(resource, productId) {
        return resource.get({id: productId}).$promise.then(function onSuccess(data) {
            return ModalService.showModal({
                templateUrl: require("./product-details.modal.html"),
                controller: "ProductDetailsModal",
                controllerAs: "productDetailsModalCtrl",
                inputs: {$attrs: {product: data}}
            }).then(function(modal) {
                modal.element.modal({
                    backdrop: "static",
                    keyboard: false
                });
                return modal.close.then(function(result) {
                    return result;
                });
            });
        }, function onError(response) {
            FlashBag.apiError(response);
        });
    }

    this.showSalesRepProductDetails = function(productId) {
        return getProductDetails(salesRepResource, productId);
    };

    this.showProductDetails = function(productId) {
        return getProductDetails(customerResource, productId);
    }
});



//////////////////
// WEBPACK FOOTER
// ./customer/app-core/product-details-modal/product-details-modal.service.js
// module id = 865
// module chunks = 0